import React, {useEffect, useState} from 'react';
import sellFactorData from "./sellFactorData"
import ObjectDataHolder from "../Hooks/ObjectDataHolder";
import SellFactorKOL from "./FactorKOL/SellFactorKOL";
import SellFactorJOZSadan from "./FactorJOZ/SellFactorJOZSadan";
import Loader from "../Loader";
import _axios from "../../httpService"
import {prefixUrl} from "../../utils/utilsData";
import {useLocation, useNavigate} from "react-router-dom";
import utilsFunction from "../../utils/utilsFunction";
import {calculateSumOfEachRowSadan} from "./SellFactorFunctionsSadan";
import Swal from "sweetalert2";
import "./SellFactorSaden.scss"

const SellFactorSadan = () => {

  const myLocation = useLocation();
  const navigateTo = useNavigate()

  const [sendData, setSendData] = ObjectDataHolder();
  console.log("sendData :::", sendData)
  const [initialData, setInitialData] = ObjectDataHolder();
  const [componentData, setComponentData] = ObjectDataHolder();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (prefixUrl() === null) {
      // alert(prefixUrl)
      window.location.reload()
    }

    if (myLocation.state?.id && myLocation.state?.id !== "undefined") {
      const id = myLocation.state.id
      _axios.get(prefixUrl() + "/groceryStoreSellFactor/?request=factorSubmittedData&factorId=" + id).then(res => {

        const data = res.data;
        if (data.status) {

          const factorData = data.data.factorData;
          for (let key in factorData) {

            if(!factorData[key] || factorData[key]===""){
              factorData[key]=""

            }

          }

          setInitialData(data.data.initialData)
          setComponentData(sellFactorData.componentData);


          const temp = {...factorData}

          //
          temp.priceData.forEach(v => {
            v.uniqId = utilsFunction.randomNumberGenerator();
          })


          temp.tableData = calculateSumOfEachRowSadan(temp.tableData)



          setSendData({...temp, bank: data.data.initialData.bank , tax: data.data.initialData.tax , showOrderId:data.data.initialData.showOrderId})
          setLoading(false)
        } else {
          setComponentData({hasAccessToStoreRoom: data.status, showMessageIfHasNotAccessToStoreRoom: data.message})
          setLoading(false)
          Swal.fire({
            title: data.message,
            text: "لطفا بعد از اعمال تغییرات مجددا تلاش کنید.",
            icon: 'error',
            showCancelButton: false,
            allowOutsideClick: true,
            showConfirmButton: true,
            confirmButtonText: 'برو به داشبورد'
          }).then((result) => {
            if (result.isConfirmed) {
              navigateTo("/dashboard")
            }
          })

        }
      })

    } else {
      // _axios.get(prefixUrl() + "/clothingShopFactor/?request=initialData").then(res => {
              _axios.get(prefixUrl() + "/groceryStoreSellFactor/?request=initialData").then(res => {

        const data = res.data;
        if (data.status) {
          // console.log(sellFactorData.initialSendData)
          // console.log(sendData)
          // console.log(setSendData)
          const tempS  = {...sellFactorData.initialSendData, bank: data.data.bank,tax: data.data.tax , showOrderId:data.data.showOrderId }
          setSendData(tempS)
          console.log(tempS)
          // setSendData({...sendData, bank: data.data.bank})
          setInitialData(data.data)

          setComponentData(sellFactorData.componentData);
          setLoading(false)
        } else {
          setComponentData({hasAccessToStoreRoom: data.status, showMessageIfHasNotAccessToStoreRoom: data.message})
          setLoading(false)
          Swal.fire({
            title: data.message,
            text: "لطفا بعد از اعمال تغییرات مجددا تلاش کنید.",
            icon: 'error',
            showCancelButton: false,
            allowOutsideClick: true,
            showConfirmButton: true,
            confirmButtonText: 'برو به داشبورد'
          }).then((result) => {
            if (result.isConfirmed) {
              navigateTo("/dashboard")
            }
          })
        }
      })

    }
  }, [])

  return (
    <>
      {/*<div className={'text-center w-100 bg-danger rounded'}>sadanShop</div>*/}
      <div className={"factor-component my__factorSadan"}>
        {loading ? <Loader/> :
          componentData.hasAccessToStoreRoom !== false ?
            <>
              <SellFactorKOL
                sendData={sendData}
                setSendData={setSendData}
                initialData={initialData}
                componentData={componentData}
                setComponentData={setComponentData}
              />
              <SellFactorJOZSadan
                sendData={sendData}
                setSendData={setSendData}
                initialData={initialData}
                componentData={componentData}
                setComponentData={setComponentData}
              />
            </>
            :
            <h2
              // className={"d-flex align-items-center  justify-content-center"}

            >{componentData.showMessageIfHasNotAccessToStoreRoom}</h2>
        }


      </div>
    </>
  );
};

export default SellFactorSadan;
